import Component from "../abstracts/Component";
import {isbot} from "isbot";
import WishlistLogic from "../logics/WishlistLogic";
import TrackingComponent from "./TrackingComponent";
import QuickAddComponent from "../components/QuickAddComponent";

/**
 Recommendation Engine Component
 */
export default class RecommendationEngineComponent extends Component {
  static get SELECTORS() {
    return {
      RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER: "#recommendation-engine-products-container",
      carouselCards: '#carouselCards',
      wishlistButton: "[data-js-wishlist]",
      nextArrow: ".next-arrow",
      prevArrow: ".prev-arrow",
    };
  }

  constructor(compEl) {
    super(compEl);
    this.recommendationEngineProductsContainer = this.$component.querySelector(RecommendationEngineComponent.SELECTORS.RECOMMENDATION_ENGINE_PRODUCTS_CONTAINER);
    this.trackingComponent = new TrackingComponent();
    this.wishlistLogic = new WishlistLogic();
    this.quickAddComponent = new QuickAddComponent(compEl, this.SELECTORS);
  }

  static get CONSTANTS() {
    let contextPath = document.getElementsByTagName("HTML")[0].getAttribute("data-context");
    return {
      RECOMMENDATION_ENGINE_URL: contextPath + "/ajax/recommendation",
      GET: "GET",
    };
  }

  render() {
    if (this.$component) {
      if (this.recommendationEngineProductsContainer.dataset.disableSlick !== 'true') {
        this.importSlick();
      }
      this.setup(this.$component);
    }
    this.wishlistLogic.render();
  }

  getMarketingOpts(recommendationComponent) {
    let opts = {};
    opts.webRecommendationHtmlData = true;
    opts.template = recommendationComponent.dataset.template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.saleMode = recommendationComponent.dataset.salemode; // BIA-2346
    opts.enableQuickAdd = recommendationComponent.dataset.enableQuickAdd;
    return opts;
  }

  getSimilarOpts(recommendationComponent) {
    let opts = {};
    opts.similarHtmlData = true;
    opts.template = recommendationComponent.dataset.template;
    opts.codes = recommendationComponent.dataset.codes;
    opts.saleMode = recommendationComponent.dataset.salemode; // BIA-2346
    opts.enableQuickAdd = recommendationComponent.dataset.enableQuickAdd;
    return opts;
  }

  async fetchServer(paramsObj) {
    const params = new URLSearchParams();
    for (let key in paramsObj) {
      params.append(key, paramsObj[key]);
    }
    const response = await fetch(RecommendationEngineComponent.CONSTANTS.RECOMMENDATION_ENGINE_URL + "?" + params.toString().replace(/\+/gi, "%20")).catch((error) => {
      console.warn(error);
    });

    if (response.ok) {
      this.recommendationEngineProductsContainer.innerHTML = await response.text();
      if (this.recommendationEngineProductsContainer.dataset.disableSlick !== 'true') {
        this.initCarousel(this.recommendationEngineProductsContainer.querySelector(RecommendationEngineComponent.SELECTORS.carouselCards));
      }
      this.handleWishlist(this.recommendationEngineProductsContainer);
      this.quickAddComponent.reinitializeComponents();
      this.$emit(this.$customEvents.CAROUSEL.carouselLoaded, { carousel: this.$component });
    } else {
      await this.tryAgain();
    }
  }

  async tryAgain() {
    const opts = this.getSimilarOpts(this.$component);
    const params = new URLSearchParams();
    for (let key in opts) {
      params.append(key, opts[key]);
    }
    const response = await fetch(RecommendationEngineComponent.CONSTANTS.RECOMMENDATION_ENGINE_URL + "?" + params.toString().replace(/\+/gi, "%20")).catch((error) => {
      console.warn(error);
    });
    if (response.ok) {
      this.recommendationEngineProductsContainer.innerHTML = await response.text();
      if (this.recommendationEngineProductsContainer.dataset.disableSlick !== 'true') {
        this.initCarousel(this.recommendationEngineProductsContainer.querySelector(RecommendationEngineComponent.SELECTORS.carouselCards));
      }
      this.handleWishlist(this.recommendationEngineProductsContainer);
      this.quickAddComponent.reinitializeComponents();
      this.$emit(this.$customEvents.CAROUSEL.carouselLoaded, { carousel: this.$component });
    } else {
      this.$component.classList.add("hidden");
    }
  }

  // handle carousel
  initCarousel(carouselContainer) {
    const productCards = carouselContainer?.querySelectorAll(".c-carousel-product-card");
    const nextArrow = this.$component.querySelector(RecommendationEngineComponent.SELECTORS.nextArrow);
    const prevArrow = this.$component.querySelector(RecommendationEngineComponent.SELECTORS.prevArrow);

    if (productCards.length > 4) {
      nextArrow.style.display = "block";
      prevArrow.style.display = "block";
    } else {
      nextArrow.style.display = "none";
      prevArrow.style.display = "none";
    }

    const options = {
      arrows: productCards.length > 4,
      centerMode: true,
      slidesToShow: 4,
      centerPadding: "112px",
      prevArrow: prevArrow,
      nextArrow: nextArrow,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            arrows: false,
            centerPadding: "76px",
            slidesToShow: 2,
          },
        },
        {
          breakpoint: 768,
          arrows: false,
          settings: {
            centerPadding: "86px",
            slidesToShow: 1,
          },
        },
      ],
    };
    $(carouselContainer).slick(options);
  }

  importSlick() {
    this.moduleLoader.loadCarouselAndExecute(
      (module) => {
        // initialized after successful fetch
        //this.initCarousel();
      },
      (error) => {
        console.error("failed to load slick ", error.stack);
      },
    );
  }

  // handle click on wishlist button
  handleWishlist(cardArray) {
    const wishlistButtons = cardArray.querySelectorAll(RecommendationEngineComponent.SELECTORS.wishlistButton);
    if (wishlistButtons) {
      wishlistButtons.forEach((btn) => {
        const addUrl = btn.dataset.addUrl;
        const removeUrl = btn.dataset.removeUrl;
        const productCode = btn.dataset.code;
        const addedMessage = btn.dataset.addedMessage;
        const removedMessage = btn.dataset.removedMessage;
        const code = btn.dataset.code;
        btn.addEventListener("click", () => {
          const isAdding = btn.dataset.jsWishlist === "empty";
          const url = (isAdding ? addUrl : removeUrl) + code;
          fetch(url, { method: "POST" })
            .then((response) => {
              return response.json();
            })
            .then((text) => {
              if (isAdding) {
                btn.dataset.jsWishlist = "full";
                this.$emit(this.$customEvents.PRODUCT_EVENTS.addedtowish, { qty: text, elem: btn, msg: addedMessage });
                this.trackingComponent.trackAction("wishlistAdd", {code: productCode});
              } else {
                btn.dataset.jsWishlist = "empty";
                this.$emit(this.$customEvents.PRODUCT_EVENTS.removedfromwish, { qty: text.count, elem: btn, msg: removedMessage });
              }
            })
            .catch((error) => this.warn(error));
        });
      });
    }
  }

  setup(recommendationComponent) {
    const userAgentString = navigator.userAgent;
    if (!isbot(userAgentString)) {
      this.fetchServer(this.getMarketingOpts(recommendationComponent));
    } else {
      this.$component.classList.add("hidden");
    }
  }
}
